import { FormattedMessage } from "react-intl";
import RejectedIcon from "../../../components/Common/SvgIcons/SocialIcons/RejectedIcon";
import { moderateContributions } from "./moderateContributions";

export const rejected = {
  label: <FormattedMessage id="Rejected_Txt" />,
  path: (tenantName) => `${moderateContributions.path(tenantName)}/rejected`,
  icon: (fill) => <RejectedIcon fill={fill} />,
  searchPlaceHolder: "Search rejected contents by name",
};
